import classnames from 'classnames';
import { useNavigate } from 'react-router-dom';
import styles from './HowItWorksSection.module.scss';
import almanaqueTitle from '../../images/almanaque-title.svg';
import oficinasTitle from '../../images/oficinas-title.svg';
import almanaqueImage from '../../images/almanaque-image.png';
import oficinasImage from '../../images/oficinas-image.png';
import Button from '../Button';

function HowItWorksSection() {
  const navigate = useNavigate();

  return (
    <div className={styles.howItWorks}>
      <div className={styles.container}>
        <h2>Como Funciona?</h2>

        <div className={styles.cards}>
          <div className={styles.cardContainer}>
            <div className={styles.card}>
              <div className={classnames(styles.cardContent, styles.almanaque)}>
                <img
                  src={almanaqueImage}
                  alt="Almanaque preview"
                  className={styles.preview}
                />
                <img
                  src={almanaqueTitle}
                  alt="Almanaque"
                  className={styles.title}
                />
              </div>
            </div>
            <div className={styles.button}>
              <Button variant="pink">Saiba mais</Button>
            </div>
          </div>

          <div className={styles.cardContainer}>
            <div className={styles.card}>
              <div className={classnames(styles.cardContent, styles.oficina)}>
                <img
                  src={oficinasImage}
                  alt="Oficinas preview"
                  className={styles.preview}
                />
                <img
                  src={oficinasTitle}
                  alt="Oficinas"
                  className={styles.title}
                />
              </div>
            </div>
            <div className={styles.button}>
              <Button variant="pink" onClick={() => navigate('/oficinas')}>Saiba mais</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HowItWorksSection;
